<template>
  <div class="main_div">
    <section id="container" class="cmdp_main"  style="padding-top:120px">
      <h1>키오스크 사용 현황</h1>
      <div  class="mgt20">
        <!-- <div style="width: 30%; float: right; text-align: right; font-size: 22px; line-height: 44px;">
            <button class="large_btn orange" style="width: 100px; float: right; margin-left: 20px;">새로고침</button>
            2023/10/04 09:36:43
        </div> -->
        <kendo-multiselect
            class="w15"
            ref="facilityRef"
            id="cdNm"
            :tag-mode="'single'"
            :data-source="zone1DepthList"
            :data-value-field="'cdId'"
            :data-text-field="'cdNm'"
            :auto-close="false"
            @change="onChangeFacility"
            :tag-template="`<span class='k-input'>#:values.length# 사업장 선택됨 </span>`"
        >
        </kendo-multiselect>
        <kendo-multiselect
            class="w15 mgl10"
            ref="areaRef"
            id="cdNm"
            :tag-mode="'single'"
            :data-source="zone2DepthList"
            :data-value-field="'cdId'"
            :data-text-field="'cdNm'"
            :auto-close="false"
            @change="onChangeArea"
            :tag-template="`<span class='k-input'>#:values.length# 거점 선택됨 </span>`"
        >
        </kendo-multiselect>
        <kendo-multiselect
            class="w15 mgl10"
            ref="kioskRef"
            id="cdNm"
            :tag-mode="'single'"
            v-model="selectedKioskList"
            :data-source="kioskList"
            :data-value-field="'kioskNo'"
            :data-text-field="'kioskNm'"
            :auto-close="false"
            :tag-template="`<span class='k-input'>#:values.length# 키오스크 선택됨 </span>`"
        >
        </kendo-multiselect>
        <button class="mid_btn orange mgl10" @click="callReportApi">검색</button>
        <ul class="list_company">
          <li v-for="(item, idx) in selectedKioskList">{{ kioskList.find(kioskItem => kioskItem.kioskNo === item).kioskNm }}
            <span class="k-icon k-i-close" @click="onClickDeleteKiosk(idx)"></span>
          </li>
        </ul>
      </div>
      <div class="box_flex">
        <!-- 키오스크 수발신 현황 -->
        <div class="w60 ai_box_bg">
          <div class="box_flex">
            <div class="w50 txt_l">
              <div class="small_title_wrap">
                <h2>키오스크 수발신 현황</h2>
              </div>
              <div class="ai_box_bg mgt10">
                <div class="box_flex">
                  <h2 class="txt_c w50">
                    발신 <span class="txt_o txt_r" style="font-size: 25px;">{{ totalSendCnt }}</span>
                  </h2>
                  <h2 class="txt_c w50">
                    수신 <span class="txt_o txt_r" style="font-size: 25px;">{{ totalReceiveCnt }}</span>
                  </h2>
                </div>
              </div>
            </div>
            <div class="w50">
              <div>
                <button class="mgl10 w15 mid_btn" :class="{'orange' : dateGbn==='01'}" @click="onChangeDateGbn('01'); callReportApi();">일주일</button>
                <button class="mgl10 w15 mid_btn" :class="{'orange' : dateGbn==='02'}" @click="onChangeDateGbn('02'); callReportApi();">월간</button>
                <button class="mgl10 w15 mid_btn" :class="{'orange' : dateGbn==='03'}" @click="onChangeDateGbn('03'); callReportApi();">직접 선택</button>
                <button class="mgl10 w20 mid_btn" @click="excelDownload"><i class="download_icon"></i>
                  <span>다운로드</span>
                </button>
              </div>
              <div class="mgt10">
                <kendo-datepicker
                    ref="frstRgstDtStartDtRef"
                    :disabled="isDisableStartDt"
                    :placeholder="'년/월/일'"
                    :format="dateFormatter"
                    @change="callReportApi"
                >
                </kendo-datepicker>
                <span class="mgl5 mgr5">-</span>
                <kendo-datepicker
                    ref="frstRgstDtEndDtRef"
                    :disabled="isDisableEndDt"
                    class="mgr5"
                    :placeholder="'년/월/일'"
                    :format="dateFormatter"
                    @change="callReportApi"
                >
                </kendo-datepicker>
              </div>
            </div>
          </div>
          <kendo-grid
              ref="gridRef"
              class="basic_table mt10"
              :data-source="kioskReceptionInfo"
              :pageable-always-visible="true"
              :pageable-page-sizes="[5, 10, 20, 50, 100, 500, 1000]"
              :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }">
          </kendo-grid>
        </div>

        <!-- 하드웨어 현황 -->
        <div class="ai_box_bg w40">
          <div class="small_title_wrap">
            <div class="fr necessary">* 이상발생시 메일로 안내가 발송되니 참고용으로 확인 바랍니다.</div>
            <h2>하드웨어 상태</h2>
          </div>
          <div class="ai_box_bg mgt10">
            <div class="box_flex">
              <h2 class="txt_c w50 bd_r">
                키오스크 -  {{kioskHwTotal.kioskTotalCnt}}대
                <div class="box_flex">
                  <h3 class="w50 txt_d mgt10">
                    정상<span class="txt_g mgl10">{{kioskHwTotal.kioskWorkingCnt}}</span>
                  </h3>
                  <h3 class="w50 txt_d mgt10" :class="{'w50 txt_d red': kioskHwTotal.kioskErrorCnt > 0}">
                    이상 <span class="txt_o mgl10">{{kioskHwTotal.kioskErrorCnt}}</span>
                  </h3>
                </div>
              </h2>
              <h2 class="txt_c w50 bd_r">
                무인 보관함 -  {{kioskHwTotal.lockerTotalCnt}}대
                <div class="box_flex">
                  <h3 class="w50 txt_d mgt10">
                    정상<span class="txt_g mgl10">{{kioskHwTotal.lockerWorkingCnt}}</span>
                  </h3>
                  <h3 class="w50 txt_d mgt10" :class="{'w50 txt_d red': kioskHwTotal.lockerErrorCnt > 0}">
                    이상 <span class="txt_o mgl10">{{kioskHwTotal.lockerErrorCnt}}</span>
                  </h3>
                </div>
              </h2>
              <h2 class="txt_c w50">
                라벨 출력기 -  {{kioskHwTotal.printerTotalCnt}}대
                <div class="box_flex">
                  <h3 class="w50 txt_d mgt10">
                    정상<span class="txt_g mgl10">{{kioskHwTotal.printerWorkingCnt}}</span>
                  </h3>
                  <h3 class="w50 txt_d mgt10" :class="{'w50 txt_d red': kioskHwTotal.printerErrorCnt > 0}">
                    이상 <span class="txt_o mgl10">{{kioskHwTotal.printerErrorCnt}}</span>
                  </h3>
                </div>
              </h2>
            </div>
          </div>
          <kendo-grid ref="sendGridRef"
                      class="basic_table mt10"
                      :data-source="kioskHwReport"
                      :columns="kioskHwColumn"
                      :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }">
          </kendo-grid>
          <div class="small_title_wrap mgt20">
            <div class="box_flex w100">
              <div class="w50 txt_l">
                <h2>보관함 시간별 현황</h2>
              </div>
              <div class="w50 txt_r mgt10">
                <button class="mgl10 w15 mid_btn" :class="{'orange' : hourlyDateGbn==='01'}" @click="onChangeHourlyDateGbn('01'); callHourlyReportApi();">일간</button>
                <button class="mgl10 w15 mid_btn" :class="{'orange' : hourlyDateGbn==='02'}" @click="onChangeHourlyDateGbn('02'); callHourlyReportApi();">주간</button>
                <button class="mgl10 w15 mid_btn" :class="{'orange' : hourlyDateGbn==='03'}" @click="onChangeHourlyDateGbn('03'); callHourlyReportApi();">누적</button>
              </div>
            </div>
            <div class="mgt10">
              <kendo-datepicker
                  ref="hourlyFrstRgstDtStartDtRef"
                  :placeholder="'년/월/일'"
                  :format="'yyyy/MM/dd'"
                  :disabled="isDisableHourlyStartDt"
              >
              </kendo-datepicker>
              <span class="mgl5 mgr5">-</span>
              <kendo-datepicker
                  ref="hourlyFrstRgstDtEndDtRef"
                  class="mgr5"
                  :placeholder="'년/월/일'"
                  :format="'yyyy/MM/dd'"
                  :disabled="isDisableHourlyEndDt"
                  @change="callHourlyReportApi"
              >
              </kendo-datepicker>
            </div>
          <chart
              ref="hourlyChartRef"
              style="width: 100%; height:290px"
              :render-as="'canvas'"
              :chart-area-background="''"
              :legend="{
                 visible: true,
                 position: 'top'
              }"
              :valueAxis="{
                        majorGridLines: {visible: true},
                        labels: {format: '{0}건'},
                        line: {visible: false},
                        axisCrossing: {value: '-10'}
                     }"
              :categoryAxis="{
                       majorGridLines: {visible: true},
                       labels: {rotation: 'auto', format: '{0}시', step: 1},
                     }"
              :tooltip="{visible: true,template: '#= series.name #: #= value #건'}"
              :series="[{type: 'column',
                      field: 'cnt',
                      categoryField: 'hour'
                      }]"
              :data-source="hourlyReportList"
              :theme="'fiori'"
          ></chart>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {ZoneMixin} from "@/mixin/Mixin";
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";
import EtnersCommonUtil from "@/common/etners.common.util";
import {saveExcel} from "@progress/kendo-vue-excel-export";
import EtnersDateTimeUtil from "@/common/etners.datetime.util";

import { Chart } from '@progress/kendo-charts-vue-wrapper';

export default {
  name: "AdminCmdpReport",
  mixins: [ZoneMixin],
  components: {
    'chart': Chart,
  },
  mounted() {
    const vm = this
    // 전체 사업장 세팅
    vm.$refs.facilityRef.kendoWidget().value(vm.zone1DepthList)
    vm.onChangeFacility()
    vm.getKioskList()
    vm.onChangeDateGbn('01')
    vm.onChangeHourlyDateGbn('01')
    vm.callReportApi()
    vm.callHwReportApi()
    vm.callHourlyReportApi()
  },
  watch: {
    selectedKioskList () {
      const vm = this
      const kendoGridHeaderAttributes = {style: 'font-weight: bold; text-align : center;', class: 'bd_r'}

      let tempColumns = []
      for (let i=0; i< vm.selectedKioskList.length; i++) {
        const kioskNo = vm.selectedKioskList[i]
        tempColumns[i] = {
          title: vm.kioskList.find(kioskItem => kioskItem.kioskNo === kioskNo).kioskNm,
          headerAttributes: kendoGridHeaderAttributes,
          columns: [
            {
              title: "발신",
              template (dateItem) {
                return !!dateItem.cnt[kioskNo] ? (dateItem.cnt[kioskNo].sendCnt !== 0 ) ? dateItem.cnt[kioskNo].sendCnt : '-' : '-'
              }
            },{
              title: "수신",
              headerAttributes: kendoGridHeaderAttributes,
              template (dateItem) {
                return !!dateItem.cnt[kioskNo] ? (dateItem.cnt[kioskNo].receiveCnt !== 0 ) ? dateItem.cnt[kioskNo].receiveCnt : '-' : '-'
              }
            }
          ]
        }
      }

      // 그리드 column 지정
      vm.gridColumn = [
        {
          title: "날짜별",
          headerAttributes: kendoGridHeaderAttributes,
          field: "date",
          template (dataItem) {
            if (vm.dateGbn === '02') {
              return `20${dataItem.date}`
            } else {
              return dataItem.date
            }
          }
        },
        ...tempColumns,
        {
          title: "합계",
          headerAttributes: kendoGridHeaderAttributes,
          columns: [
            {
              title: "발신",
              field: "totalSendCnt",
              attributes : {style: "background-color:rgb(251, 255, 204); font-weight: bold;"},
              template (dateItem) {
                return dateItem.totalSendCnt
              }
            },{
              title: "수신",
              field: "totalReceiveCnt",
              attributes : {style: "background-color:rgb(251, 255, 204); font-weight: bold;"},
              template (dateItem) {
                return dateItem.totalReceiveCnt
              }
            }
          ]
        }
      ]
      if(!!vm.$refs.gridRef) {
        vm.$refs.gridRef.kendoWidget().setOptions({columns:vm.gridColumn})
      }
    }
  },
  methods: {
    onChangeFacility () {
      const vm = this
      if (!!vm.$refs.facilityRef) {
        vm.facilityList = {
          idList: vm.$refs.facilityRef.kendoWidget().value(),
          nmList: vm.$refs.facilityRef.kendoWidget().dataItems()
        }

        // zone2Depth 초기화
        let zone2DepthList = []
        vm.facilityList.idList.forEach(item => {
          zone2DepthList = [
            ...zone2DepthList,
            ...(!!vm.zone2DepthMap.get(item) ? vm.zone2DepthMap.get(item) : [])
          ]
        })

        vm.$refs.areaRef.kendoWidget().setDataSource(zone2DepthList)
        vm.$refs.areaRef.kendoWidget().value(zone2DepthList)
        vm.onChangeArea()
      }
    },
    onChangeArea () {
      const vm = this
      if (!!vm.$refs.areaRef) {
        vm.areaList = {
          idList: vm.$refs.areaRef.kendoWidget().value(),
          nmList: vm.$refs.areaRef.kendoWidget().dataItems()
        }
      }
      // 키오스크 선택값 세팅 (area - kiosk 매핑 고려)
      if (!!vm.areaList) {
        let areaNmList = []
        vm.areaList.nmList.forEach(item => {
          areaNmList.push(item.cdNm.split(" ")[0])
        })

        let selectedKioskList = []
        vm.kioskList.forEach(item => {
          for (let areaNm of areaNmList) {
            if (item.kioskNm.indexOf(areaNm) > -1) {
              selectedKioskList.push(item.kioskNo)
            }
          }
        })
        vm.selectedKioskList = selectedKioskList
      }
    },
    getKioskList () {
      const vm = this
      const facilityList = vm.$refs.facilityRef.kendoWidget().value()
      const areaList = vm.$refs.areaRef.kendoWidget().value()

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/kioskNmList.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        facilityList: facilityList,
        areaList: areaList
      }
      ApiUtil.post(url, params, {isShowLoadingBar:false}).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        vm.kioskList = response.data.resultData
        vm.$refs.kioskRef.kendoWidget().setDataSource(vm.kioskList)
        if (vm.kioskList.length > 0) {
          let kioskNoList = []
          vm.kioskList.forEach(item => {
            kioskNoList.push(item.kioskNo)
          })
          vm.selectedKioskList = kioskNoList
        }
      })
    },
    onClickDeleteKiosk (idx) {
      const vm = this
      vm.selectedKioskList.splice(idx, 1)
    },
    currentPageFilterOption() {
      const vm = this
      const refs = vm.$refs
      let currentSearchDataObj = {}
      currentSearchDataObj.facilityList = vm.$refs.facilityRef.kendoWidget().value()
      currentSearchDataObj.areaList = vm.$refs.areaRef.kendoWidget().value()
      currentSearchDataObj.kioskList = vm.$refs.kioskRef.kendoWidget().value()

      if (!!vm.dateGbn) {
        currentSearchDataObj.dateGbn = vm.dateGbn
      }
      if(refs.frstRgstDtStartDtRef.kendoWidget().value() !== undefined){
        const frstRgstDtStartDt = refs.frstRgstDtStartDtRef.kendoWidget().value()
        if(!!frstRgstDtStartDt){
          currentSearchDataObj.frstRgstDtStartDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(frstRgstDtStartDt, '/')
        }
      }
      if(refs.frstRgstDtEndDtRef.kendoWidget().value() !== undefined){
        const frstRgstDtEndDt = refs.frstRgstDtEndDtRef.kendoWidget().value()
        if(!!frstRgstDtEndDt){
          currentSearchDataObj.frstRgstDtEndDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(frstRgstDtEndDt, '/')
        }
      }
      return currentSearchDataObj
    },
    callReportApi () {
      const vm = this
      let pageSize = 12
      if (vm.dateGbn === '01') {
        pageSize = 7
      }
      vm.kioskReceptionInfo = new kendo.data.DataSource({
        name: 'kioskReceptionInfo',
        page: 1,
        pageSize: pageSize,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/dashboard/kioskReceiptReport.json`,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            cache: false
          },
          parameterMap: function (options, operation) {
            if (operation === 'read') {
              const params = {
                loginUserToken: vm.loginUserToken,
                skip: options.skip,
                take: options.take,
                sort: options.sort,
                page: options.page,
                pageSize: options.pageSize,
                ...vm.currentPageFilterOption(),
                requestType: 'PAGING',
              }
              sessionStorage.setItem('LAST_ROUTE_PARAMS', kendo.stringify(params))
              return kendo.stringify(params)
            }
            if (operation !== 'read' && options.models) {
              return {models: kendo.stringify(options.models)}
            }
          }
        },
        schema: {
          type: 'json',
          parse: function (response) {
            if (response.resultStatus.messageCode !== '2000') {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
            return response
          },
          total: function (response) {
            return response.resultData.totalElementCnt
          },
          data: function (response) {
            if (response.resultStatus.messageCode === '2000') {
              const resultData = response.resultData
              vm.totalSendCnt = resultData.totalSendCnt
              vm.totalReceiveCnt = resultData.totalReceiveCnt
              return resultData.kioskReceiptInfoList
            } else {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
          }
        },
        error: function (e) {
        }
      })
    },
    callHwReportApi () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/dashboard/kioskHwReport.json`
      const params = {
        loginUserToken: vm.loginUserToken,
      }
      ApiUtil.post(url, params, {isShowLoadingBar:false}).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        vm.kioskHwReport = response.data.resultData
      vm.kioskHwReport.map(item => {
        if (item.kioskNo){
          vm.kioskHwTotal.kioskTotalCnt ++
        }
        if (item.kioskStatus === '99'){
          vm.kioskHwTotal.kioskWorkingCnt ++
        } else {
          vm.kioskHwTotal.kioskErrorCnt ++
        }
        if(item.storageType === '01'){
          vm.kioskHwTotal.lockerTotalCnt ++
          if (item.lockerStatus === '99'){
            vm.kioskHwTotal.lockerWorkingCnt ++
          } else {
            vm.kioskHwTotal.lockerErrorCnt ++
          }
        }
        if(item.regiPrinterStatus !== null){
          vm.kioskHwTotal.printerTotalCnt ++
          if (item.regiPrinterStatus === '정상'){
            vm.kioskHwTotal.printerWorkingCnt ++
          } else {
            vm.kioskHwTotal.printerErrorCnt ++
          }
        }
        if(item.deliPrinterStatus !== null){
          vm.kioskHwTotal.printerTotalCnt ++
          if (item.deliPrinterStatus === '정상'){
            vm.kioskHwTotal.printerWorkingCnt ++
          } else {
            vm.kioskHwTotal.printerErrorCnt ++
          }
        }
        return item
      })
      })
    },
    callHourlyReportApi () {
      const vm = this
      const refs = vm.$refs

      let currentSearchDataObj = {}
      if (!!vm.hourlyDateGbn) {
        currentSearchDataObj.dateGbn = vm.hourlyDateGbn
      }
      if(refs.hourlyFrstRgstDtStartDtRef.kendoWidget().value() !== undefined){
        const frstRgstDtStartDt = refs.hourlyFrstRgstDtStartDtRef.kendoWidget().value()
        if(!!frstRgstDtStartDt){
          currentSearchDataObj.frstRgstDtStartDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(frstRgstDtStartDt, '/')
        }
      }
      if(refs.hourlyFrstRgstDtEndDtRef.kendoWidget().value() !== undefined){
        const frstRgstDtEndDt = refs.hourlyFrstRgstDtEndDtRef.kendoWidget().value()
        if(!!frstRgstDtEndDt){
          currentSearchDataObj.frstRgstDtEndDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(frstRgstDtEndDt, '/')
        }
      }

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/dashboard/lockerHourlyReport.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        ...currentSearchDataObj
      }
      ApiUtil.post(url, params, {isShowLoadingBar:false}).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        vm.hourlyReportList = new kendo.data.DataSource({
          data: response.data.resultData,
          group: 'lockerNm',
          sort: {
            field: 'hour',
            dir: 'asc'
          },
        })
      })
    },
    excelDownload () {
      const vm = this
      const lastRequestParameters = JSON.parse(sessionStorage.getItem('LAST_ROUTE_PARAMS'))
      const excelParams = JSON.parse(JSON.stringify(lastRequestParameters))
      excelParams.requestType = 'EXPORT'
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/dashboard/kioskReceiptReport.json`
      ApiUtil.post(url, excelParams).then(response => {
        let kioskReceiptInfoList = response.data.resultData.kioskReceiptInfoList
        if (EtnersCommonUtil.isNotEmpty(kioskReceiptInfoList)) {

          // 엑셀 다운로드 시 template 사용 불가. 따라서 데이터 처리 작업 필요
          kioskReceiptInfoList = kioskReceiptInfoList.map(item => {
            vm.selectedKioskList.forEach(kioskNo => {
              if (item.cnt[kioskNo] === undefined) {
                item.cnt[kioskNo] = { sendCnt: '-', receiveCnt: '-' }
              } else {
                ['sendCnt', 'receiveCnt'].forEach(cnt => {
                  item.cnt[kioskNo][cnt] = item.cnt[kioskNo][cnt] !== undefined && item.cnt[kioskNo][cnt] !== 0 ? item.cnt[kioskNo][cnt] : '-'
                })
              }
            })
            return item
          })

          let gridColumn = vm.gridColumn.map(item => {
            item.headerCellOptions = { textAlign: 'center', borderLeft: '1px', borderRight: '1px' }
            item.width = '150px'
            if (item.columns){
              item.children = item.columns
              item.children.forEach((child, i)=>{
                child.headerCellOptions = { textAlign: 'center', borderLeft: i === 0 ? '1px' : '' }
                child.width = '75px'

                const kioskInfo = vm.kioskList.find(kioskItem => kioskItem.kioskNm === item.title)
                child.field = !!!kioskInfo ? child.field : (child.title === '발신' ? `cnt["${kioskInfo.kioskNo}"]["sendCnt"]` : `cnt["${kioskInfo.kioskNo}"]["receiveCnt"]`)
              })
            }
            return item
          })

          saveExcel({
            data: kioskReceiptInfoList,
            fileName: `키오스크 사용 현황_${EtnersDateTimeUtil.dateToYYYYMMDD(new Date())}.xlsx`,
            columns: gridColumn,
          })
        } else {
          kendo.alert('다운로드 할 자료가 없습니다.')
        }
      })
    },
    onChangeDateGbn (dateGbn) {
      const vm = this
      const refs = vm.$refs
      vm.dateGbn = dateGbn
      if (dateGbn === '01') {
        vm.dateFormatter = 'yyyy/MM/dd'
        vm.isDisableStartDt = true
        vm.isDisableEndDt = true
        const now = new Date()
        const startDt = new Date(now.getFullYear(), now.getMonth(), now.getDate()-7)

        refs.frstRgstDtStartDtRef.kendoWidget().value(startDt)
        refs.frstRgstDtEndDtRef.kendoWidget().value(now)
      } else if (dateGbn === '02') {
        vm.dateFormatter = 'yyyy/MM'
        vm.isDisableStartDt = true
        vm.isDisableEndDt = true
        const now = new Date()
        const startDt = new Date(now.getFullYear(), now.getMonth()-12, now.getDate())

        refs.frstRgstDtStartDtRef.kendoWidget().value(startDt)
        refs.frstRgstDtEndDtRef.kendoWidget().value(now)
      } else if (dateGbn === '03'){
        vm.dateFormatter = 'yyyy/MM/dd'
        vm.isDisableStartDt = false
        vm.isDisableEndDt = false

        refs.frstRgstDtStartDtRef.kendoWidget().value('')
        refs.frstRgstDtEndDtRef.kendoWidget().value(new Date())
      }
    },
    onChangeHourlyDateGbn (dateGbn) {
      const vm = this
      const refs = vm.$refs
      vm.hourlyDateGbn = dateGbn
      if (dateGbn === '01') {
        vm.isDisableHourlyStartDt = true
        vm.isDisableHourlyEndDt = false
        const now = new Date()

        refs.hourlyFrstRgstDtStartDtRef.kendoWidget().value('')
        refs.hourlyFrstRgstDtEndDtRef.kendoWidget().value(now)
      } else if (dateGbn === '02') {
        vm.isDisableHourlyStartDt = true
        vm.isDisableHourlyEndDt = true
        const now = new Date()
        const startDt = new Date(now.getFullYear(), now.getMonth(), now.getDate()-7)

        refs.hourlyFrstRgstDtStartDtRef.kendoWidget().value(startDt)
        refs.hourlyFrstRgstDtEndDtRef.kendoWidget().value(now)
      } else if (dateGbn === '03') {
        vm.isDisableHourlyStartDt = true
        vm.isDisableHourlyEndDt = true
        const now = new Date()

        refs.hourlyFrstRgstDtStartDtRef.kendoWidget().value('')
        refs.hourlyFrstRgstDtEndDtRef.kendoWidget().value(now)
      }
    }
  },
  data () {
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      lastRouteParams: [],
      kioskList: [],
      dateFormatter: 'yyyy/MM/dd',
      dateGbn: "01",
      hourlyDateGbn: "01",
      selectedKioskList: [],

      isDisableStartDt: true,
      isDisableEndDt: true,
      isDisableHourlyStartDt: true,
      isDisableHourlyEndDt: false,

      totalSendCnt: 0,
      totalReceiveCnt: 0,
      kioskReceptionInfo: {},
      gridColumn: [],

      kioskHwReport: {},
      kioskHwTotal: {
        kioskTotalCnt : 0,
        kioskWorkingCnt : 0,
        kioskErrorCnt : 0,
        lockerTotalCnt : 0,
        lockerWorkingCnt : 0,
        lockerErrorCnt : 0,
        printerTotalCnt : 0,
        printerWorkingCnt : 0,
        printerErrorCnt : 0,
      },
      kioskHwColumn: [
        {
          title: " ",
          width: '20%',
          headerAttributes: {style: 'font-weight: bold; text-align : center;'},
          attributes: {"class": "table-cell bd_r"},
          field: "kioskNm",
          template (dataItem) {
            let res = dataItem.kioskNm
            if(dataItem.kioskStatus === '99' && dataItem.regiPrinterStatus === '정상' && dataItem.deliPrinterStatus === '정상' && ((dataItem.storageType === '02' && dataItem.kioskStatus === '99') || dataItem.storageType === '01')){
              res = dataItem.kioskNm
            } else {
              res = `<b class="red">${dataItem.kioskNm}<span class="k-icon k-i-warning red"></span></b>`
            }
            return res
          }
        },
        {
          width: '10%',
          title: "키오스크",
          headerAttributes: kendoGridHeaderAttributes,
          field: "kioskStatus",
          template (dataItem) {
            let res = dataItem.kioskStatus
            if(dataItem.kioskStatus === '99'){
              res = '정상'
            } else {
              res = `<b class="red">확인 필요</b>`
            }
            return res
          }
        },
        {
          width: '10%',
          title: "무인보관함",
          headerAttributes: kendoGridHeaderAttributes,
          field: "lockerStatus",
          template (dataItem) {
            let res = dataItem.lockerStatus
            if(dataItem.storageType === '02'){
              res = "미설치"
            } else if(dataItem.kioskStatus === '99'){
              res = '정상'
            } else {
              res = `<b class="red">확인 필요</b>`
            }
            return res
          }
        },
        {
          width: '10%',
          title: "등기 라벨",
          headerAttributes: kendoGridHeaderAttributes,
          field: "regiPrinterStatus",
          template (dataItem) {
            let res = dataItem.regiPrinterStatus
            if(dataItem.regiPrinterStatus === '정상'){
              res = '정상'
            } else {
              res = `<b class="red">${dataItem.regiPrinterStatus}</b>`
            }
            return res
          }
        },
        {
          width: '10%',
          title: "택배 라벨",
          headerAttributes: kendoGridHeaderAttributes,
          field: "deliPrinterStatus",
          template (dataItem) {
            let res = dataItem.deliPrinterStatus
            if(dataItem.deliPrinterStatus === '정상'){
              res = '정상'
            } else {
              res = `<b class="red">${dataItem.deliPrinterStatus}</b>`
            }
            return res
          }
        },
      ],

      hourlyReportList: [],
      hourlyChartValueAxis: {
        labels: {
          format: "{0}건"
        }
      }
    }
  }
}
</script>

<style scoped>

</style>